var map = {
	"./access-reasons_controller.ts": 3564,
	"./access-request_controller.ts": 1132,
	"./associated-person-form_controller.ts": 75037,
	"./associated-person-photos_controller.ts": 36028,
	"./associated-persons-report_controller.ts": 36876,
	"./audit-trail_controller.ts": 12836,
	"./csv-upload-associated-persons_controller.ts": 24822,
	"./delete_controller.ts": 4463,
	"./dob-entry_controller.ts": 7382,
	"./duplicate-check_controller.ts": 28986,
	"./index-associated-persons_controller.ts": 79160,
	"./issue-ap-section_controller.ts": 23537,
	"./mercure-grant_controller.ts": 16992,
	"./multi-input_controller.ts": 70918,
	"./photo-gallery_controller.ts": 61391
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79980;